import type {RefinementListItem} from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import {type RefinementListProps, useRefinementList, type UseRefinementListProps} from "react-instantsearch";
import {Panel} from "@/instantsearch/components/Panel";
import {useConfigContext} from "@/ConfigProvider";

type FilterColorProps = UseRefinementListProps & {
    title: string;
    searchEnabled?: boolean;
};

type RefinementListItemWithColor = RefinementListItem & { color: string };
const transformItemsColorLabel: RefinementListProps["transformItems"] = (items): RefinementListItemWithColor[] => {
    return items.map((item) => ({
        ...item,
        label: item.label.split("||")[1],
        color: item.label.split("||")[0],
    }));
};

export function FilterColor(props: FilterColorProps) {
    const {
        items: rawItems,
        refine,
        canToggleShowMore,
        isShowingMore,
        toggleShowMore,
        canRefine,
        searchForItems,
    } = useRefinementList({
        ...props,
        transformItems: transformItemsColorLabel,
    }, {
        $$widgetType: 'dc.colorRefinementList'
    });
    const {tc} = useConfigContext();
    const items = rawItems as RefinementListItemWithColor[];
    if (!items || items.length === 0 || !canRefine) return;
    return (
        <Panel title={props.title}>
            <div className="ais-filterColor">
                {props.searchEnabled && (
                    <div className="inputGroup searchBar">
                        <input
                            type="search"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck={false}
                            placeholder={`${props.title} durchsuchen …`}
                            onChange={(event) => searchForItems(event.currentTarget.value)}
                            autoComplete="off"
                        />
                        <span className="inputGroup__addon">
							<i className="icon icon-search" aria-hidden={true}></i>
						</span>
                    </div>
                )}
                <ul className="ais-filterColor__list">
                    {items.map((item) => (
                        <li key={item.label} className="ais-filterColor__item">
                            <label htmlFor={item.label}
                                   className={`ais-filterColor__label ${item.isRefined ? "is-active" : ""}`}>
                                <div className={"ais-filterColor__dot"} style={{backgroundColor: item?.color}}
                                     aria-hidden={true}/>
                                <input
                                    className="ais-filterColor__checkbox"
                                    id={item.label}
                                    type="checkbox"
                                    checked={item.isRefined}
                                    onChange={() => refine(item.value)}
                                />
                                <span>{item.label}</span>
                            </label>
                        </li>
                    ))}
                    {items.length === 0 && <li>{tc.noEntriesFound}</li>}
                </ul>

                {canToggleShowMore && (
                    <button type="button" onClick={toggleShowMore} className="buttonLink ais-filterColor__showMoreButton">
                        {isShowingMore ? (
                            <>
                                <i className="icon icon-minus" aria-hidden={true}></i>
                                <span>{tc.showLess}</span>
                            </>
                        ) : (
                            <>
                                <i className="icon icon-plus" aria-hidden={true}></i>
                                <span>{tc.showMore}</span>
                            </>
                        )}
                    </button>
                )}
            </div>
        </Panel>
    );
}
